import { FC, ChangeEvent, KeyboardEvent } from "react";

import { Box, Spinner, useMultiStyleConfig } from "@chakra-ui/react";

import { Button } from "@components/buttons";
import TextInput from "@components/TextInput";
import useUpdateValue from "@hooks/useUpdateValue";

import { TInputFormProps } from "./types";

const InputForm: FC<TInputFormProps> = ({ id, value, isDisabled, isLoading, submitLabel, onSubmit, ...rest }) => {
  const [innerValue, updateValue] = useUpdateValue(value || "");
  const styles = useMultiStyleConfig("SubmitInput", {});

  const handleInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = evt.target;
    updateValue(inputValue);
  };

  const handleSubmit = () => {
    if (isLoading || isDisabled) {
      return;
    }
    onSubmit(innerValue || "");
  };

  const handleInputKeyDown = (evt: KeyboardEvent<HTMLInputElement>) => {
    if (evt.key === "Enter") {
      evt.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box position="relative">
      <TextInput
        {...rest}
        id={id}
        isDisabled={isDisabled}
        value={innerValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        isFormik={false}
        sx={styles.input}
      />
      <Button
        id={id && `submit-${id}`}
        variant="secondary"
        label={isLoading ? <Spinner /> : submitLabel}
        onClick={handleSubmit}
        isDisabled={isDisabled}
        sx={styles.floatingButton}
      />
    </Box>
  );
};
export default InputForm;
